export enum CollectionType {
	SHOP = "SHOP",
	WISHLIST = "WISHLIST"
}
